import { createNumberMask } from 'redux-form-input-masks';

const brCurrencyMask = createNumberMask({
  prefix: 'R$ ',
  decimalPlaces: 2,
  locale: 'pt-BR',
});

export default brCurrencyMask;
